// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"55642b15","185":"e9433b76","198":"2eb971c3","498":"d72a19ff","703":"baa843af","787":"96753a15","880":"07a81841"}[chunkId] + ".chunk.js";
};